// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.game-space {
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  gap: 15px;
  justify-content: flex-start;
  height: 600px;
}

h1 {
  font-size: 25px;
  margin-left: 20px;
  margin-bottom: -10px;
  margin-top: 20px;
}

.domino-zone {
  /* width: 1150px; */
  display: flex;
  flex-wrap: wrap;
  align-content: space-evenly;
}

.save-domino {
  justify-content: flex-start;
  margin-left: 20px;
}

.save-domino > div {
  position: relative;
}

.house-of-domino {
  justify-content: space-evenly;
}

.text-is-not-right {
  position: absolute;
  left: -50px;
  bottom: -15px;
  font-size: 25px;
  font-family: "Manrope";
  color: red;
}

.connect-elem {
  position: absolute;
  left: -15px;
  bottom: -15px;
  width: 40px;
  height: 40px;
}

.connect-elem-rotate {
  transform: rotate(90deg);
}

.text-ending-game {
  margin: 100px auto;

  font-size: 40px;
  font-family: "Manrope";
  color: #20677b;
}
`, "",{"version":3,"sources":["webpack://./src/TaskWindows/Domino/styles/GameSpace.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;;EAElB,eAAe;EACf,sBAAsB;EACtB,cAAc;AAChB","sourcesContent":[".game-space {\n  margin-left: auto;\n  margin-right: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  justify-content: flex-start;\n  height: 600px;\n}\n\nh1 {\n  font-size: 25px;\n  margin-left: 20px;\n  margin-bottom: -10px;\n  margin-top: 20px;\n}\n\n.domino-zone {\n  /* width: 1150px; */\n  display: flex;\n  flex-wrap: wrap;\n  align-content: space-evenly;\n}\n\n.save-domino {\n  justify-content: flex-start;\n  margin-left: 20px;\n}\n\n.save-domino > div {\n  position: relative;\n}\n\n.house-of-domino {\n  justify-content: space-evenly;\n}\n\n.text-is-not-right {\n  position: absolute;\n  left: -50px;\n  bottom: -15px;\n  font-size: 25px;\n  font-family: \"Manrope\";\n  color: red;\n}\n\n.connect-elem {\n  position: absolute;\n  left: -15px;\n  bottom: -15px;\n  width: 40px;\n  height: 40px;\n}\n\n.connect-elem-rotate {\n  transform: rotate(90deg);\n}\n\n.text-ending-game {\n  margin: 100px auto;\n\n  font-size: 40px;\n  font-family: \"Manrope\";\n  color: #20677b;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
